import React from 'react'

import classes from './styles'

import Score from '../Score'
import Result from './components/Result'
import Answer from './components/Answer'

class Question extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hide: true,
      roundId: null,
    }

    this.timeoutId = null
  }

  componentDidMount = () => {
    this.showWithDelay()
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.question.id !== this.props.question.id) {
      this.showWithDelay()
    }
  }

  showWithDelay = () => {
    this.timeoutId = setTimeout(() => {
      if (this.state.hide) this.setState({
        hide: false
      })
    }, 100)
  }

  hide = () => {
    this.setState({
      hide: true,
    })
  }

  render() {
    const { question, result, currentAnswer, toAnswer } = this.props
    const hiddenClass = this.state.hide ? classes.hide : ''

    return (
      <div className={[classes.question, hiddenClass].join(' ')}>
        <Score />

        <h2 className={classes.questionText}>
          {question.text}
        </h2>

        <div>
          {question.answers.map((answer, index) => (
            <Answer
              key={`answer-${index}`}
              answer={answer}
              currentAnswer={currentAnswer}
              toAnswer={toAnswer}
            />
          ))}
        </div>

        {result ?
          <Result hideQuestion={this.hide} result={result} />
        :''}

      </div>
    )
  }
}

Question.propTypes = {
  question: React.PropTypes.object.isRequired,
  result: React.PropTypes.object,
  toAnswer: React.PropTypes.func.isRequired,
}

export default Question


// WEBPACK FOOTER //
// ./src/components/Question/Question.jsx